import React, { useState, useEffect } from 'react';
import CargomaticCard from 'components/v2/card';
import { useTranslation } from 'react-i18next';
import Switch from 'react-switch';
import EditButton from 'components/v2/buttons/EditButton';
import CustomersAPIUtils, { savePortProIntegration, } from 'utils/CustomersAPIUtils';
import Spinner from 'components/ui/Spinner';
import CargomaticInput from 'components/v2/input';
import SessionStore from 'stores/SessionStore';
import Roles from 'constants/UserRoles';
import { encrypt, decrypt } from 'utils/Encryption';
import CargomaticAlert from 'components/ui/Alert';
const PortProIntegration = ({ carrierId, cardClassName }) => {
    const { t } = useTranslation();
    const [loadingData, setLoadingData] = useState(true);
    const [editMode, setEditMode] = useState(true);
    const [enabled, setEnabled] = useState(false);
    const [tokenValue, setTokenValue] = useState(null);
    const [showAlert, setShowAlert] = useState(false);
    const [serverPortProValue, setServerPortProValue] = useState(null);
    const isSupportRole = () => {
        const userRoles = SessionStore.getUser().roles;
        return userRoles.includes(Roles.SUPPORT);
    };
    const fetchCarrierData = async () => {
        const { entity: { portpro }, } = await CustomersAPIUtils.getCarrierNonAdmin(carrierId);
        const { token } = portpro;
        if (token) {
            setServerPortProValue(portpro);
            setEnabled(portpro === null || portpro === void 0 ? void 0 : portpro.enabled);
            setTokenValue(isSupportRole() ? decrypt(token) : token);
        }
    };
    const savePortProSettings = async () => {
        if (!isSupportRole()) {
            return;
        }
        if ((serverPortProValue === null || serverPortProValue === void 0 ? void 0 : serverPortProValue.token) || tokenValue) {
            setEnabled(enabled);
            const isEnabled = await savePortProIntegration({
                payload: {
                    carrierId,
                    token: encrypt(tokenValue),
                    enabled,
                },
            });
            setEnabled(isEnabled);
        }
        else {
            setShowAlert(true);
        }
    };
    const handleTokenInputChange = (val) => {
        setTokenValue(val);
        if (showAlert && val) {
            setShowAlert(false);
        }
    };
    const renderHeader = () => {
        return (React.createElement("header", { className: "flex items-center justify-between" },
            React.createElement("h3", { className: "my-0" }, t('TMS_INTEGRATIONS')),
            !editMode && React.createElement(EditButton, { onClick: () => setEditMode(true) })));
    };
    useEffect(() => {
        fetchCarrierData().finally(() => setLoadingData(false));
    }, []);
    return (React.createElement(CargomaticCard, { className: cardClassName, header: renderHeader }, loadingData ? (React.createElement("div", { className: "flex justify-center items-center" },
        React.createElement(Spinner, { showMessage: false }))) : (React.createElement("div", null,
        showAlert && (React.createElement(CargomaticAlert, { type: "error", title: t('NO_CARRIER_TOKEN') })),
        React.createElement("div", { className: "flex justify-between" },
            React.createElement("div", { className: "font-medium flex items-center" }, t('PORTPRO')),
            React.createElement("div", { "data-testid": "portpro-switcher", className: "py-2" },
                React.createElement(Switch, { className: "mb-0", checked: enabled, onChange: setEnabled }))),
        React.createElement("div", { className: "flex justify-between items-end mt-3" },
            React.createElement(CargomaticInput, { label: t('CARRIER_TOKEN'), className: "flex-1 mr-3", type: "password", disabled: !isSupportRole(), onChange: handleTokenInputChange, value: tokenValue, showPasswordIcon: isSupportRole() }),
            React.createElement("div", { className: "h-10" },
                React.createElement("button", { disabled: !tokenValue || !isSupportRole(), className: "button button-green", onClick: savePortProSettings }, t('SAVE'))))))));
};
export default PortProIntegration;
